import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CtaDivider() {
  return <section className="py-16 lg:py-24 bg-[#4AA6CF] relative overflow-hidden" data-id="element-24">
      {/* Decorative background elements */}
      <div className="absolute inset-0 pointer-events-none opacity-10" data-id="element-25">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" data-id="element-26" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" data-id="element-27" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-28">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 text-center lg:text-left" data-id="element-29">
          <div className="max-w-2xl" data-id="element-30">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-6 tracking-tight" data-id="element-31">
              Ready to Secure Your Professional Fingerprints?
            </h2>
            <p className="text-white/90 text-lg md:text-xl font-medium leading-relaxed" data-id="element-32">
              Book your individual office appointment or schedule a mobile group
              session today.
            </p>
          </div>

          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-33">
            <a href="#/booking" className="inline-flex items-center gap-3 bg-white text-[#4AA6CF] px-10 py-5 rounded-full font-extrabold text-xl shadow-2xl shadow-black/10 hover:shadow-white/20 transition-all" data-id="element-34">
              <span data-id="element-35">Book Now</span>
              <ArrowRightIcon className="h-6 w-6" data-id="element-36" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}